<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Create New Coupon</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-0">Add New Coupon</h2>
        <button class="btn btn-primary" (click)="goToBulkUploadPage()">Bulk Upload</button>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">

        <div formArrayName="newCouponGroups">
            <div class="mb-md-4 position-relative" *ngFor="let item of newCouponGroups().controls; let i=index"
                [formGroupName]="i">
                <div class="row row-gap-4">
                    <div class="d-flex flex-column row-gap-1 col-12">
                        <div class="form-group mb-0 w-100">
                            <p class="h5 font-weight-normal mb-2 mb-md-3">Coupon Details</p>
                            <div class="d-flex flex-wrap column-gap-4">
                                <div class="custom-control custom-radio flex-shrink-0">
                                    <input type="radio" class="custom-control-input" value="Generic"
                                        formControlName="coupontype" id="Generic">
                                    <label for="Generic"
                                        class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium">Generic</label>
                                </div>
                                <div class="custom-control custom-radio flex-shrink-0">
                                    <input type="radio" class="custom-control-input" value="Brands"
                                        formControlName="coupontype" id="Brands">
                                    <label for="Brands"
                                        class="custom-control-label cursor-pointer font-weight-semibold text-gray-medium">Brands</label>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newCouponGroups().controls[i].get('coupontype').invalid && newCouponGroups().controls[i].get('coupontype').touched"
                                class="small text-danger">
                                <div *ngIf="newCouponGroups().controls[i].get('coupontype').errors?.required">
                                    Coupon Type is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="row">
                            <div class="d-flex flex-column row-gap-1 col">
                                <div class="form-group floating_form_field mb-0 w-100">
                                    <input type="text" formControlName="title" id="title" class="form-control"
                                        placeholder="Title" [(ngModel)]=couponsection.title>
                                    <label>Coupon Code</label>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div *ngIf="newCouponGroups().controls[i].get('title').invalid && newCouponGroups().controls[i].get('title').touched"
                                        class="small text-danger">
                                        <div *ngIf="newCouponGroups().controls[i].get('title').errors?.required">Coupon
                                            Code
                                            is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex flex-column row-gap-1 col">
                                <div class="form-group floating_form_field mb-0 w-100">
                                    <input type="text" formControlName="couponvalue" id="couponvalue"
                                        class="form-control" placeholder="Value in(₹)"
                                        [(ngModel)]=couponsection.couponvalue>
                                    <label>Value in(₹)</label>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div *ngIf="newCouponGroups().controls[i].get('couponvalue').invalid && newCouponGroups().controls[i].get('couponvalue').touched"
                                        class="small text-danger">
                                        <div *ngIf="newCouponGroups().controls[i].get('couponvalue').errors?.required">
                                            Coupon Value is required
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex flex-column row-gap-1 col">
                                <div class="form-group floating_form_field mb-0 w-100">
                                    <input class="form-control hasDatepicker" autocomplete="off" (click)="d1.toggle()"
                                        (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedDate($event)"
                                        id="startdate" type="text" formControlName="startdate" ngbDatepicker
                                        #d1="ngbDatepicker" [minDate]="minDate" required>
                                    <label>Start Date</label>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div *ngIf="newCouponGroups().controls[i].get('startdate').invalid && newCouponGroups().controls[i].get('startdate').touched"
                                        class="small text-danger">
                                        <div *ngIf="newCouponGroups().controls[i].get('startdate').errors?.required">
                                            Start Date is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex flex-column row-gap-1 col">
                                <div class="form-group floating_form_field mb-0 w-100">
                                    <input class="form-control hasDatepicker" autocomplete="off" (click)="d2.toggle()"
                                        (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedToDate($event)"
                                        id="enddate" type="text" formControlName="enddate" ngbDatepicker
                                        #d2="ngbDatepicker" [minDate]="minToDate" required>
                                    <label>End Date</label>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div *ngIf="newCouponGroups().controls[i].get('enddate').invalid && newCouponGroups().controls[i].get('enddate').touched"
                                        class="small text-danger">
                                        <div *ngIf="newCouponGroups().controls[i].get('enddate').errors?.required">End
                                            Date is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex flex-column row-gap-1 col">
                                <div class="form-group floating_form_field mb-0 w-100">
                                    <input type="text" formControlName="couponcount" id="couponcount"
                                        class="form-control" placeholder="Coupon Count"
                                        [(ngModel)]=couponsection.couponcount>
                                    <label>
                                        Coupon Count
                                    </label>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <div *ngIf="newCouponGroups().controls[i].get('couponcount').invalid && newCouponGroups().controls[i].get('couponcount').touched"
                                        class="small text-danger">
                                        <div *ngIf="newCouponGroups().controls[i].get('couponcount').errors?.required">
                                            Coupon Count is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column row-gap-1 col-12 col-md-8">
                        <div class="form-group floating_form_field mb-0 w-100">
                            <input type="text" formControlName="coupondetails" id="coupondetails" class="form-control"
                                placeholder="Coupon Details" [(ngModel)]=couponsection.coupondetails>
                            <label>
                                Coupon Detail
                            </label>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div *ngIf="newCouponGroups().controls[i].get('coupondetails').invalid && newCouponGroups().controls[i].get('coupondetails').touched"
                                class="small text-danger">
                                <div *ngIf="newCouponGroups().controls[i].get('coupondetails').errors?.required">
                                    Coupon Detail is required
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-4 d-flex flex-column row-gap-1">
                        <div class="d-flex align-items-center justify-content-between upload_field"
                            (click)="uploadImages.click()">
                            <span class="text-truncate mr-3">{{imageName ? imageName : 'Upload Logo'}}</span>
                            <svg-icon src="../../../assets/images/icons/upload.svg"></svg-icon>
                        </div>
                        <input onclick="this.value = null" formControlName="couponimage" id="couponimage" type="file"
                            class="d-none" accept=".png, .jpg, .jpeg" (change)="onFileChange($event)" #uploadImages>

                        <!-- <div *ngIf="newCouponGroups().controls[i].get('couponimage').invalid && newCouponGroups().controls[i].get('couponimage').touched"
                            class="small text-danger">
                            <div *ngIf="newCouponGroups().controls[i].get('couponimage').errors?.required">
                                Coupon Image is required
                            </div>
                        </div> -->
                        <!-- <div class="small text-muted">Images must not exceed height and width of 750px and 420px</div> -->
                    </div>
                </div>
            </div>
        </div>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button" (click)="goToListPage()">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>